import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderExecutionHoldTime extends BaseModelAPI {
	static entity = '';
	static entityName = 'workorderexecutionholdtime';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.workOrderExecutionId = '';
			this.workOrderExecution = {};
			this.startTime = '';
			this.remark = '';
			this.endTime = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}